var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-top-brokers-with-delayed-refresh',{staticClass:"sidebar__top-brokers",attrs:{"sidebar-layout":""}})}
var staticRenderFns = []

export { render, staticRenderFns }